module.exports = __webpack_public_path__ + "img/买家秀示例图.36a3f2b0.jpeg";